import {Controller} from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['item'];

    connect() {
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (this.motionQuery.matches || !('animate' in Element.prototype)) {
            return;
        }

        this.frameRequested = false;
        this.entryFrame = null;
        this.animations = [];
        this.requestRender = this.requestRender.bind(this);
        this.render = this.render.bind(this);

        this.element.classList.add('hero-motion-ready');
        this.animations = this.itemTargets.map((item, index) => item.animate([
            {opacity: 0, transform: 'translate3d(0, 34px, 0)'},
            {opacity: 1, transform: 'translate3d(0, 0, 0)'},
        ], {
            duration: 900,
            delay: 120 + index * 115,
            easing: 'cubic-bezier(.22, 1, .36, 1)',
            fill: 'both',
        }));

        this.entryFrame = window.requestAnimationFrame(() => {
            this.entryFrame = window.requestAnimationFrame(() => {
                this.element.classList.add('is-hero-visible');
            });
        });

        window.addEventListener('scroll', this.requestRender, {passive: true});
        window.addEventListener('resize', this.requestRender);
        this.render();
    }

    disconnect() {
        window.removeEventListener('scroll', this.requestRender);
        window.removeEventListener('resize', this.requestRender);

        if (this.entryFrame !== null) {
            window.cancelAnimationFrame(this.entryFrame);
        }

        this.animations?.forEach((animation) => animation.cancel());
        this.element.classList.remove('hero-motion-ready', 'is-hero-visible');
    }

    requestRender() {
        if (!this.frameRequested) {
            window.requestAnimationFrame(this.render);
            this.frameRequested = true;
        }
    }

    render() {
        const bounds = this.element.getBoundingClientRect();
        const progress = Math.min(1, Math.max(0, -bounds.top / Math.max(bounds.height, 1)));

        this.element.style.setProperty('--hero-image-offset', `${progress * -20}px`);
        this.element.style.setProperty('--hero-image-scale', `${1.035 + progress * 0.012}`);
        this.element.style.setProperty('--hero-copy-offset', `${progress * -12}px`);
        this.frameRequested = false;
    }
}
